import { render, staticRenderFns } from "./Apresentacao.vue?vue&type=template&id=0bd3e118&"
import script from "./Apresentacao.vue?vue&type=script&lang=js&"
export * from "./Apresentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports